import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleProduct = (id, enabled = true) => {
  return useQuery({
    queryKey: ['viewProductDetails', id],
    enabled: !!id && enabled, 
    queryFn: async ({ queryKey }) => {
      const productId = queryKey[1];   
      const res = await api.get(`/products/show/${productId}`);
      return res.data;
    },
  });
};